<template>
  <div class="user-tile">
    <div class="content-container" @click="modalVisible = true">
      <div class="is-flex">
        <h1 class="is-size-7 has-text-weight-bold is-expanded">
          {{ user.employeeId }}
        </h1>
        <p
          class="is-size-7 is-uppercase"
          :class="{ 'has-text-danger': user.role === 'admin' }"
        >
          {{ user.role }}
        </p>
      </div>
      <h1 class="is-size-5">{{ user.name }}</h1>
      <div class="is-flex">
        <p class="is-size-6 is-expanded">{{ user.mobile }}</p>
        <p
          class="is-size-7 is-uppercase"
          style="margin-top: 4px;"
          :class="{ 'has-text-success': user.active }"
        >
          {{ user.active ? "Active" : "Inactive" }}
        </p>
      </div>
    </div>
    <div class="modal" :class="{ 'is-active': modalVisible }">
      <div class="modal-background" @click="onModalClose"></div>
      <div class="modal-content">
        <div class="box">
          <ul>
            <li class="list-item">
              <router-link :to="`/user/view/${user._id}`" class="has-text-grey"
                >View</router-link
              >
            </li>
            <li class="list-item">
              <router-link :to="`/user/edit/${user._id}`" class="has-text-grey"
                >Edit</router-link
              >
            </li>
            <li class="list-item">
              <router-link
                :to="`/user/delete/${user._id}`"
                class="has-text-danger"
                >Delete</router-link
              >
            </li>
          </ul>
        </div>
      </div>
      <div class="modal-close" @click="onModalClose"></div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["user"],
  data() {
    return {
      modalVisible: false
    };
  },
  methods: {
    onModalClose() {
      let component = this;
      component.modalVisible = false;
      console.log("modal-close");
    }
  }
};
</script>
<style lang="scss" scoped>
.user-tile {
  border-bottom: 1px solid $white-ter;
  margin-bottom: 20px;
  &:last-of-type {
    margin-bottom: 0;
  }
  &:last-of-type {
    border-bottom-color: transparent;
  }

  .modal {
    .box {
      width: 95%;
      margin: auto;
      text-align: center;
    }
  }
}
</style>
